// ABOUTME: Maps icon name strings from custom page config to @ds/coolshop icon components.
// ABOUTME: Provides a finite lookup with a default fallback icon.

import {
    AccountTreeIcon,
    BarChartIcon,
    BusinessCenterIcon,
    CheckIcon,
    ContactsIcon,
    DashboardIcon,
    DescriptionIcon,
    FolderIcon,
    LanguageIcon,
    ListIcon,
    LocalOfferIcon,
    ReceiptIcon,
    SearchIcon,
    SettingsIcon,
    WorkIcon,
} from '@ds/coolshop';
import { ReactElement } from 'react';

const iconMap: Record<string, ReactElement> = {
    AccountTreeIcon: <AccountTreeIcon />,
    BarChartIcon: <BarChartIcon />,
    BusinessCenterIcon: <BusinessCenterIcon />,
    CheckIcon: <CheckIcon />,
    DashboardIcon: <DashboardIcon />,
    ContactsIcon: <ContactsIcon />,
    DescriptionIcon: <DescriptionIcon />,
    FolderIcon: <FolderIcon />,
    LanguageIcon: <LanguageIcon />,
    ListIcon: <ListIcon />,
    LocalOfferIcon: <LocalOfferIcon />,
    ReceiptIcon: <ReceiptIcon />,
    SearchIcon: <SearchIcon />,
    SettingsIcon: <SettingsIcon />,
    WorkIcon: <WorkIcon />,
};

const defaultIcon = <ListIcon />;

export function resolveIcon(iconName?: string | null): ReactElement {
    if (!iconName) return defaultIcon;
    return iconMap[iconName] ?? defaultIcon;
}
